"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), Object.defineProperty(exports, "FeatureFlagVariationType", {
  enumerable: !0,
  get: function get() {
    return _types.FeatureFlagVariationType;
  }
}), Object.defineProperty(exports, "VariationConfiguration", {
  enumerable: !0,
  get: function get() {
    return _variationConfiguration.VariationConfiguration;
  }
});
var _variationConfiguration = require("./variationConfiguration"),
  _types = require("./types");